import React, {useState, useEffect} from 'react';
import {AutoField} from 'components/forms/fields';
import EndSection from '../EndSection';
import {Typography, Grid, Card, CardContent} from '@material-ui/core';
import {Show} from 'components/utils/Show';
import fields from '../cg719s/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {useFieldData} from 'components/forms/hooks';
import SignIt from './SignIt';

//import {useGetProfile} from 'hooks';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: '330px',
        border: '0.5px solid lightgray',
    },
    content: {
        padding: '1rem',
        '&:last-child': {
            paddingBottom: '0rem', // sadly this is necessary
        },
    },
    shaded: {
        backgroundColor: theme.palette.gray.light2,
    },
    loading: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '1em',

        '&::after': {
            content: `'Saving...'`,
            position: 'absolute',
            fontWeight: 'bold',
            color: theme.palette.gray.medium,
            transform: 'translate(0, 0)',
        },
        '&::before': {
            backgroundColor: 'white',
            content: `''`,
            opacity: '.5',
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: '1',
            transform: 'translate(0, 0)',
        },
    },
}));

const SummaryCard = ({shaded = false, ...props}) => {
    const classes = useStyles();
    const [deck_position_served] = useFieldData('deck_position_served');
    const [engine_position_served] = useFieldData('engine_position_served');
    const days_gl = useFieldData('days_gl');
    const days_inland = useFieldData('days_inland');
    const days_nc = useFieldData('days_nc');
    const total_number_days = useFieldData('total_number_days');
    return (
        <Card className={clsx(classes.root, {[classes.shaded]: shaded})}>
            <CardContent className={classes.content}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Show condition={deck_position_served.length > 0}>
                            {deck_position_served}
                        </Show>
                        <Show condition={engine_position_served.length > 0}>
                            {engine_position_served}
                        </Show>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid
                            container
                            spacing={1}
                            alignItems='flex-end'
                            direction='column'
                        >
                            <Grid item xs={12}>
                                Sea Days: {total_number_days}
                            </Grid>
                            <Grid item xs={12}>
                                <Show condition={parseInt(days_gl) > 0}>
                                    Sea Days Great Lakes: {days_gl}
                                </Show>
                            </Grid>
                            <Grid item xs={12}>
                                <Show condition={parseInt(days_inland) > 0}>
                                    Sea Days Inland: {days_inland}
                                </Show>
                            </Grid>
                            <Grid item xs={12}>
                                <Show condition={parseInt(days_nc) > 0}>
                                    Sea Days Near Coastal: {days_nc}
                                </Show>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

const Address = props => {
    const {schema, initialValues} = bootstrapOldForm('Address', fields);
    const [readyToSign, setReadyToSign] = useState(false);
    const [formResult, setFormResult] = useState();
    const [formID, setFormID] = useState();
    const [imageUrl, setImageUrl] = useState();

    //const {data: profileData} = useGetProfile();
    // TO DO: Autofill info from user context/profile as initialValues. Post them if this is the first time entering?
    //blocker: profileData returns null if no data, this breaks things

    const goToSign = result => {
        setFormResult(result);
    };

    useEffect(() => {
        setReadyToSign(false);
        if (formResult?.status === 'ok') {
            setFormID(formResult?.cg719s_id);
            setImageUrl(formResult?.signed_url);
            setReadyToSign(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formResult]);
    if (readyToSign === true) {
        return <SignIt formID={formID} imageUrl={imageUrl} />;
    } else {
        return (
            <EndSection
                {...props}
                schema={schema}
                initialValues={initialValues}
                endpointOverride='cg719s/make'
                clearFormOverride
                buttonText='Sign This CG719S'
                redirectOnSuccess={false}
                successText={'CG719S Generated!'}
                myAwesomeFunction={goToSign}
            >
                <Grid item xs={12}>
                    <Typography variant='h6' align='left'>
                        Your Completed CG719S
                    </Typography>
                </Grid>
                <SummaryCard />

                <Grid item xs={12}>
                    <strong>Vessel Owner/Captain Information</strong>
                </Grid>
                {[
                    'applicant_home_address_street',
                    'applicant_home_address_city',
                    'applicant_home_address_state',
                    'applicant_home_address_zip',
                    'applicant_phone_primary',
                    'applicant_email',
                ].map(field => (
                    <Grid item xs={12} key={field}>
                        <AutoField field={fields[field]} name={field} />
                    </Grid>
                ))}

                {props.children}
            </EndSection>
        );
    }
};

export default Address;
export {SummaryCard};
